import { useState } from "react";
import { GrIconButton, GrIconButtonProps, GrMenu, GrMenuProps } from "@jnpmedi/grebob";

const MEATBALL_ICON_BUTTON_OPTIONS: Pick<GrIconButtonProps, "iconType" | "size" | "color" | "disabled"> = {
  iconType: "dot-horizontal",
  size: 16,
  color: "grey060",
  disabled: undefined,
};

interface DropdownButtonIconProps {
  menuOptions: Pick<GrMenuProps, "items" | "position" | "size" | "onClose">;
  iconButtonOptions?: Pick<GrIconButtonProps, "iconType" | "size" | "color" | "disabled">;
}

export function DropdownButtonIcon({ menuOptions, iconButtonOptions }: DropdownButtonIconProps) {
  const { items, position, size: menuSize, onClose: onMenuClose } = menuOptions;
  const { iconType, size: iconButtonSize, color, disabled } = iconButtonOptions || { ...MEATBALL_ICON_BUTTON_OPTIONS };

  const [anchorElement, setAnchorElement] = useState<HTMLElement | null>(null);

  const handleAnchorClose = () => {
    setAnchorElement(null);
    onMenuClose?.();
  };

  return (
    <>
      <GrIconButton
        disabled={disabled}
        iconType={iconType}
        size={iconButtonSize}
        color={color}
        onClick={(e) => setAnchorElement(e.currentTarget)}
      />
      <GrMenu onClose={handleAnchorClose} position={position} size={menuSize} anchorElement={anchorElement} items={items} />
    </>
  );
}
